/** @format */
/**
 * External dependencies
 */
import { omit } from 'lodash';

/**
 * Returns a string representation of a sorted query object.
 *
 * @param {Object} query Current state
 * @return {String}       Query Key
 */
export function getJsonString( query = {} ) {
	return JSON.stringify( query, Object.keys( query ).sort() );
}

/**
 * Returns a string representation of the availability query argument.
 *
 * @param {Object} query Current state
 * @return {String}       Query Key
 */
export function serializeQueryArgs( query = {} ) {
	return getJsonString( omit( query, [ 'page' ] ) );
}
